import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';
import styles from './styles.module.scss';

export type TagType = 'red' | 'orange' | 'green' | 'cyan' | 'gray' | 'neutral';

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
  type?: TagType;
}

const Tag = ({ type = 'gray', className, ...rest }: TagProps) => (
  <div className={classNames(styles.Tag, styles[type])} {...rest} />
);

export default Tag;
